// Función para aplicar estilos condicionales a Total Interacciones
const getInteractionStyle = totalInteractions => {
  if (totalInteractions > 15) {
    return 'bg-red-100 text-red-600';
  } else if (totalInteractions >= 5) {
    return 'bg-green-100 text-green-600';
  } else {
    return 'bg-orange-100 text-orange-600';
  }
};

// Format duration from seconds to readable format (e.g., "2m 30s" or "1h 2m 30s")
const formatDuration = seconds => {
  if (!seconds || seconds === 0) return null;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  } else {
    return `${secs}s`;
  }
};

export { getInteractionStyle, formatDuration };
